export const generarPlazosValidos = (min, max) => {
    const todos = [6, 12, 18, 24, 30, 36, 48, 60, 72, 84, 96];
    return todos.filter(p => p >= min && p <= max);
};
